// src/config/runtime.js
// Single source of truth for reading client-public runtime configuration.
// Prefers values injected at container start into window.__ENV__ (see public/env.template.js
// + docker-entrypoint.sh); falls back to build-time process.env for local `pnpm start`.
// There are 26 REACT_APP_* keys — validate by prefix rather than a hardcoded per-key list.
export function getConfig(key) {
  if (!key || !key.startsWith('REACT_APP_')) {
    throw new Error(`Config key must start with REACT_APP_: ${key}`);
  }
  const runtime = typeof window !== 'undefined' ? window.__ENV__ : undefined;
  const value = runtime ? runtime[key] : undefined;
  const usable = value !== undefined && value !== '' && !String(value).startsWith('${');
  return usable ? value : process.env[key];
}
